import { render, staticRenderFns } from "./area-restrita.vue?vue&type=template&id=877032e8"
import script from "./area-restrita.vue?vue&type=script&lang=js"
export * from "./area-restrita.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports